import axios, { AxiosInstance } from "axios";
import ConfigService from "../services/ConfigService.ts";
import { AuthContextProps } from "../providers/AuthProvider.tsx";
import authVersionService from "@/auth/services/authVersionService.ts";
import authFactory from "@/auth/services/authFactory.ts";

const authHeaders = () => {
  const promoId = ConfigService.getPromoId();
  return authVersionService.getVersionHeaders(promoId);
};

export const PromofyAuthHeaders = (context?: AuthContextProps) => {
  return {
    ...authHeaders(),
    ...(context && context.isLoggedIn && { "promofy-token": `Bearer ${context.token}` }),
  };
};
export const PromofyTokenHeaders = (context: AuthContextProps) => {
  return {
    ...(context && context.isLoggedIn && { Authorization: `Bearer ${context.token}` }),
  };
};

const httpClient: AxiosInstance = axios.create({
  baseURL: `${import.meta.env.VITE_WIDGET_GATEWAY_BASE_URL}` + authFactory.getVersionPath(),
  headers: {
    ...authHeaders(),
  },
});

export default httpClient;
